'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _appMenu = require('./app-menu.html');

var _appMenu2 = _interopRequireDefault(_appMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _appMenu2.default,
  bindings: {
    currentUser: '<'
  },
  controller: function () {
    function MenuComponent($location, $mdMedia, $mdSidenav, AuthService) {
      'ngInject';

      _classCallCheck(this, MenuComponent);

      Object.assign(this, {
        $location: $location,
        $mdMedia: $mdMedia,
        $mdSidenav: $mdSidenav,
        AuthService: AuthService
      });
    }

    _createClass(MenuComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.navLinks = [{
          state: 'dashboard',
          sref: 'dashboard',
          description: 'Dashboard',
          keywords: ['dashboard'],
          icon: 'fa-home'
        }, {
          state: 'account',
          sref: 'account',
          description: 'Manage Account',
          keywords: ['account'],
          icon: 'fa-gear'
        }, {
          state: 'company',
          sref: 'company({id: ' + this.currentUser.MemberId + '})',
          description: 'Manage Account',
          keywords: ['companies'],
          icon: 'fa-gear'
        }, {
          state: 'companies',
          sref: 'companies',
          description: 'Manage Accounts',
          keywords: ['companies', 'regulators'],
          icon: 'fa-gear'
        }, {
          state: 'products',
          sref: 'products',
          description: 'Manage Products',
          keywords: ['products'],
          icon: 'fa-leaf'
        }, {
          state: 'adverseEvents',
          sref: 'adverseEvents',
          description: 'Manage Adverse Events',
          keywords: ['adverse-events'],
          icon: 'fa-pencil-square-o'
        }, {
          state: 'userIngredients',
          sref: 'userIngredients',
          description: 'User Ingredients',
          keywords: ['user-ingredients'],
          icon: 'fa-user'
        }, {
          state: 'systemIngredients',
          sref: 'systemIngredients',
          description: 'System Ingredients',
          keywords: ['system-ingredients'],
          icon: 'fa-hdd-o'
        }, {
          state: 'mapIngredients',
          sref: 'mapIngredients',
          description: 'Map Ingredients',
          keywords: ['map-ingredients'],
          icon: 'fa-sitemap fa-rotate-90'
        }, {
          state: 'categories',
          sref: 'categories',
          description: 'Categories',
          keywords: ['/categories'],
          icon: 'fa-tags'
        }, {
          state: 'mapCategories',
          sref: 'mapCategories',
          description: 'Map Categories',
          keywords: ['map-categories'],
          icon: 'fa-sitemap fa-rotate-90'
        }, {
          state: 'memberCompliance',
          sref: 'memberCompliance',
          description: 'Member Compliance',
          keywords: ['member-compliance'],
          icon: 'fa-id-card-o'
        }, {
          state: 'reports',
          sref: 'reports',
          description: 'Reports',
          keywords: ['reports'],
          icon: 'fa-bar-chart-o'
        }];

        if (this.AuthService.isSysAdmin) {
          this.navLinks = this.navLinks.filter(function (l) {
            return l.state !== 'company';
          });
        }
      }
    }, {
      key: 'toggleIfOpenUnlocked',
      value: function toggleIfOpenUnlocked() {
        var isLockedOpen = this.$mdSidenav('left').isLockedOpen();

        if (isLockedOpen === false) {
          this.$mdSidenav('left').toggle();
        }
      }
    }, {
      key: 'isActive',
      value: function isActive(navLink) {
        var _this = this;

        return navLink.keywords.some(function (k) {
          return _this.$location.path().toLowerCase().indexOf(k) > -1;
        });
      }
    }, {
      key: 'logout',
      value: function logout() {
        this.AuthService.logout();
      }
    }, {
      key: 'welcomeMessage',
      get: function get() {
        if (this.currentUser.FirstName) {
          return 'Welcome, ' + this.currentUser.FirstName + '!';
        }

        return 'Welcome!';
      }
    }]);

    return MenuComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/app-menu/app-menu.component.js